<div class="county-filter">
    <ion-item *ngFor="let county of counties"
              class="global ion-no-padding">
        <ion-checkbox slot="start"
                      [value]="county"
                      [checked]="isChecked(county)"
                      (ionChange)="filterChanged($event)">
        </ion-checkbox>
        <ion-label>{{ county }}</ion-label>
    </ion-item>
</div>